import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=6d914a10&scoped=true&"
var script = {}
import style0 from "./Footer.vue?vue&type=style&index=0&id=6d914a10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d914a10",
  null
  
)

export default component.exports